// export const isSameUserType = ({ roleArray = [], role = '' }) => {
//   const smallRole = role?.toLowerCase();
//   const smallRoleArray = roleArray.map((e) => e.toLowerCase());
//   return smallRoleArray.includes(smallRole);
// };

export const isSameUserType = ({ roleArray = [], role = '' }) => {
  const smallRole = role?.toLowerCase();
  const smallRoleArray = roleArray.map((e) => e.toLowerCase());
  return smallRoleArray.some((type) => smallRole?.includes(type));
};